module.exports = __webpack_public_path__ + "static/media/Work-shadow.695916f3.png";